import { render, staticRenderFns } from "./ConstructorsTable.vue?vue&type=template&id=28f93271&scoped=true&"
import script from "./ConstructorsTable.vue?vue&type=script&lang=js&"
export * from "./ConstructorsTable.vue?vue&type=script&lang=js&"
import style0 from "./ConstructorsTable.vue?vue&type=style&index=0&id=28f93271&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f93271",
  null
  
)

export default component.exports